export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/e53673f1d35014610251dfa259b857bf.png";